import React, { Component, Fragment } from "react";
import ReactHtmlParser from "react-html-parser";
import { animateScroll } from "react-scroll";
import Loader from "./Loader";
const user_img = require("../assets/media/user.png");
const botImg1 = require("../assets/media/bot1.png");
const botImg2 = require("../assets/media/bot2.png");
const botImages = [botImg1, botImg2];

class MessageItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
    };
  }

  componentWillMount() {
    const { timeoutValue, message, logo } = this.props;
    const { type, mark } = message;
    setTimeout(
      () => {
        if (type === "bot")
          animateScroll.scrollToBottom({
            duration: 0,
          });
        this.setState({
          loaded: true,
        });
      },
      type === "bot" ? timeoutValue : 0
    );
  }

  render() {
    const { firstChild, logo, imageIndex = 0 } = this.props;
    const { type, message, mark, end } = this.props.message;
    const { loaded, imgIndex } = this.state;
    return (
      <Fragment>
        <div
          style={
            type === "bot"
              ? {
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                }
              : {
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  justifyContent: "flex-end",
                }
          }
        >
          {type === "bot" && (
            <img
              className="avatar"
              src={botImages[imageIndex]}
              style={{ width: 40, height: 40, marginRight: 3, padding: 3 }}
              alt="concierge"
            />
          )}

          <div
            className={`message-item-wrapper ${
              loaded ? "loaded" : ""
            } ${type} ${firstChild ? "first-child" : ""}`}
          >
            <Loader />
            <div className={`message ${logo === "bolt" ? "" : "notbolt"}`}>
              {ReactHtmlParser(message)}
            </div>
          </div>
          {type === "user" && (
            <img
              src={user_img}
              style={{ width: 40, height: 40, marginLeft: 5 }}
              alt="concierge"
              className="avatar"
            />
          )}
        </div>
      </Fragment>
    );
  }
}

export default MessageItem;



// WEBPACK FOOTER //
// ./src/components/MessageItem.js